import React from "react";
import PropTypes from "prop-types";
import { ErrorBanner } from "rhombus-react";

import "./ContentFeedMappingsValidations.css";

export default function ContentFeedMappingsValidations({ messages = []}) {
	return (
		<div className="content-feed-mappings-validations">
			<ErrorBanner
				title="Sorry, please fix the errors below and try again."
				messages={messages}
				shouldDisplay={Boolean(messages.length)}
			/>
		</div>
	);
}

ContentFeedMappingsValidations.displayName = "ContentFeedMappingsValidations";

ContentFeedMappingsValidations.propTypes = {
	messages: PropTypes.arrayOf(PropTypes.string),
};
